import { render, staticRenderFns } from "./ProdutoAnexo.vue?vue&type=template&id=50e931a0"
import script from "./ProdutoAnexo.vue?vue&type=script&lang=js"
export * from "./ProdutoAnexo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports